'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate as $c_Lapp_api_GeneralPracticeAppUpdate };
$c_Lapp_api_GeneralPracticeAppUpdate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate as $h_Lapp_api_GeneralPracticeAppUpdate };
$h_Lapp_api_GeneralPracticeAppUpdate.prototype = $c_Lapp_api_GeneralPracticeAppUpdate.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_api_GeneralPracticeAppUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_GeneralPracticeAppUpdate)));
}
export { $isArrayOf_Lapp_api_GeneralPracticeAppUpdate as $isArrayOf_Lapp_api_GeneralPracticeAppUpdate };
//# sourceMappingURL=app.api.-General-Practice-App-Update.js.map
